import { useEffect, useState } from 'react'

/**
 * Returns the latest value only after `delay` ms without a change.
 * @param delay quiet period in milliseconds
 */
export const useDebounced = <T>(value: T, delay = 500): T => {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return debounced
}
